// extracted by mini-css-extract-plugin
module.exports = {"shared":"\"../../../shared.module.css\"","xl":"1200px","container":"EmptyCart_container__2Yhh0"};